var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.membership)?_c('div',[_c('VFormBuilder',{ref:"form",attrs:{"items":_vm.items,"initial-values":_vm.membership}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }